import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaginatedResult } from "src/app/support/paginated-result";
import { TemplateReporting } from "../../models/template-reporting/template-reporting";
import { TemplateReportingCreate } from "../../models/template-reporting/template-reporting.create";
import { TemplateReportingLoad } from "../../models/template-reporting/template-reporting.load";
import { TemplateReportingUpdate } from "../../models/template-reporting/template-reporting.update";

@Injectable()
export abstract class TemplateReportingBackend {
  abstract list(): Observable<TemplateReporting[]>;

  abstract load(request: TemplateReportingLoad): Observable<TemplateReporting>;

  abstract create(request: TemplateReportingCreate): Observable<string>;

  abstract update(
    id: string,
    request: Partial<TemplateReportingUpdate>
  ): Observable<void>;

  abstract delete(id: string): Observable<void>;
}
